import { render, staticRenderFns } from "./ConfigurePortfolios.vue?vue&type=template&id=790758f8&"
import script from "./ConfigurePortfolios.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfigurePortfolios.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports